import React from 'react'

import { PlusOutlined } from '@ant-design/icons'
import ListPageHeader from '@shared/ListPageHeader'
import BrandsList from '@shared/brands/BrandsList'
import Can from '@shared/permissions/Can'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { brandService } from '@services/admin/brandService'

const AdminBrandsList: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['products', 'products.brands']}
        actions={
          <Can requiredPermission="brands:write">
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => navigate('/brands/new')}
            >
              {t('common.button.new')}
            </Button>
          </Can>
        }
      />
      <BrandsList
        service={brandService}
        role="admin"
        showMerchantColumn={false}
      />
    </div>
  )
}

export default AdminBrandsList
